import { Link } from 'react-router-dom';
import './FeedCardNew.css';
import './FeedCardNewEvent.css';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL, isPastDate } from '../../utils';
import posterImg from "../image/loadingshimmer.png";

import { RiVerifiedBadgeFill } from "react-icons/ri";
import ShareModal from './ShareModal';




export default function FeedCardNewEvent({ data, onFullModeClick }) {

    const userData = JSON.parse(localStorage.getItem("userData"));

    const [isLoaded, setIsLoaded] = useState(false);

    const [isShareModalOpen, setIsShareModalOpen] = useState(false);
    const [currentShareUrl, setCurrentShareUrl] = useState('');
    const [shareTitle, setShareTitle] = useState('');
    const [userLocation, setUserLocation] = useState({ latitude: null, longitude: null });


    const uploadBase = `${API_BASE_URL}/master/assets/uploads/`;


    const isAbsURL = (url) => {
        const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
        return ABSOLUTE_URL_REGEX.test(url);
    }

    const getImageURL = (url) => {
        if (url) {
            if (isAbsURL(url)) {
                return url;
            } else {
                return uploadBase + url;
            }
        } else {
            return url;
        }
    }

    const eventUrl = (eventData) => {
        return `${API_BASE_URL}/event/${eventData.clubName.trim().replace(/\s+/g, "-").toLowerCase()}-${eventData.cityName.trim().replace(/\s+/g, "-").toLowerCase()}-${eventData.areaName.trim().replace(/\s+/g, "-").toLowerCase()}/${eventData.name.trim().replace(/\s+/g, "-").toLowerCase()}`;
    };


    const generateEventUrl = useCallback((data) => {
        const { clubName, cityName, areaName, name } = data;
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");
        return `/event/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(name)}`;
    }, []);



    const handleShare = (e, eventData) => {
        e.preventDefault();
        e.stopPropagation();

        const url = eventUrl(eventData);
        setCurrentShareUrl(url);
        setShareTitle(`Check out ${eventData.name} at ${eventData.clubName}`);
        setIsShareModalOpen(true);
    };


    function generateClubUrl(clubName, cityName, areaName) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");
        return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
    }

    const handleAddRemoveFav = async (e, eventData) => {
        e?.preventDefault();

        const formdata = new FormData();
        formdata.append("club_id", eventData.id);
        formdata.append("user_id", userData.id);

        try {
            const response = await axios.post(`${API_BASE_URL}/master/APIs/Common/addToFav`, formdata);

            if (response.status === 200) {
                const { is_fav } = response.data; // assuming backend returns this
                if (is_fav) {
                    console.log("Added to favorites");
                } else {
                    console.log("Removed from favorites");
                }
            } else {
                console.warn("Unexpected response status:", response.status);
            }
        } catch (error) {
            console.error("Failed to add/remove favorite:", error);
        }
    };

    // Distance calculation function
    const getDistanceFromLatLonInKm = useCallback((lat1, lon1, lat2, lon2) => {
        if (!lat1 || !lon1 || !lat2 || !lon2) return 0;

        const toRad = (value) => (value * Math.PI) / 180;
        const R = 6371; // Radius of the Earth in km

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);

        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;

        return Math.round(distance.toFixed(2));
    }, []);

    const distance = useMemo(() => {
        return getDistanceFromLatLonInKm(
            userLocation.latitude,
            userLocation.longitude,
            data?.latitude,
            data?.longitude
        );
    }, [userLocation, data?.latitude, data?.longitude, getDistanceFromLatLonInKm]);

    // Get user location on mount
    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setUserLocation({ latitude, longitude });
                },
                (error) => {
                    console.error('Error getting location:', error);
                },
                {
                    timeout: 10000,
                    enableHighAccuracy: false,
                    maximumAge: 300000 // Cache for 5 minutes
                }
            );
        } else {
            console.error('Geolocation is not available in this browser.');
        }
    }, []);

    const url = `${API_BASE_URL}/master/assets/uploads/`;
    const videoRef = useRef(null);

    // Local state synced with localStorage
    const [isMuted, setIsMuted] = useState(() => {
        const stored = localStorage.getItem("isMuted");
        return stored ? JSON.parse(stored) : true;
    });

    const [isVisible, setIsVisible] = useState(false);


    // Handle mute toggle
    const handleMute = () => {

        const newMute = !isMuted;
        localStorage.setItem("isMuted", JSON.stringify(newMute));
        setIsMuted(newMute);
    };

    // Watch visibility
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setIsVisible(entry.isIntersecting),
            { threshold: 0.6 }
        );

        if (videoRef.current) {
            observer.observe(videoRef.current);
        }

        return () => {
            if (videoRef.current) {
                observer.unobserve(videoRef.current);
            }
        };
    }, []);

    // Control video playback and mute state
    useEffect(() => {
        const video = videoRef.current;
        const stored = localStorage.getItem("isMuted");
        if (video) {
            video.muted = stored === "true" ? true : false;
            if (isVisible) {
                video.play().catch(() => { });
            } else {
                video.pause();
            }
        }
    }, [isVisible, isMuted]);



    return (
        <>
            <div className="feed-card" onClick={onFullModeClick}>
                {/* Header */}



                <div className='feed-card-image-content-section-wrapper'>

                    <div className="feed-card-header">
                        <div>
                            <Link to={generateClubUrl(data?.clubName, data?.cityName, data?.areaName)} style={{ textDecoration: "none", color: "inherit" }}>
                                <img
                                    className="feed-card-avatar"
                                    src={getImageURL(data.clubLogo)}
                                    alt="Club"
                                />
                            </Link>
                        </div>
                        <div className="feed-card-header-details">

                            <h4> <Link to={generateClubUrl(data?.clubName, data?.cityName, data?.areaName)} style={{ textDecoration: "none", color: "inherit" }}>
                                {data?.clubName}
                            </Link> <span className="verified-badge"><RiVerifiedBadgeFill />
                                    {/* <span className='feed-last-seen'>• 22h ago</span> */}
                                </span></h4>
                            <p>   {data?.areaName}, {data?.cityName},{" "}
                                {distance > 0 ? `${distance}Kms` : ""}{" "}</p>
                        </div>
                        <div className="feed-card-more" onClick={(e) => handleShare(e, data)}>
                            <i class="fi fi-br-menu-dots" style={{ fontSize: '17px' }}
                            ></i></div>
                    </div>

                    <Link to={generateEventUrl(data)}>
                        <div className='feed-card-image-content-section'>

                            {/* Banner Carousel */}
                            <div className="feed-card-carousel">
                                <div className="carousel-label">Add On up to 50% Extra on Food & Beverages</div>
                                <div className='feed-event-image'>

                                    <div className="image-wrapper">
                                        {!isLoaded && (
                                            <div className="ec-skeleton ec-shimmer"></div>
                                        )}
                                        {data?.video ? (
                                            <div className='feed-event-video'>
                                                <video
                                                    ref={videoRef}
                                                    src={url + data?.video}
                                                    poster={posterImg}
                                                    autoPlay
                                                    muted={localStorage.getItem("isMuted") === "true" ? true : false}
                                                    loop
                                                    playsInline
                                                    className="live-card-video"
                                                >
                                                    <source src={url + data?.video} type="video/mp4" />
                                                </video>
                                                <div className='feed-event-video-icon-mute' onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleMute();
                                                }}>
                                                    {localStorage.getItem("isMuted") === "true" ? <i class="fi fi-rr-volume-mute volume-icon"></i> : <i class="fi fi-rr-volume volume-icon"></i>}

                                                </div>
                                            </div>
                                        ) : (
                                            <img
                                                src={getImageURL(data?.image)}
                                                alt="Live Music image"
                                                className={`event-img ${isLoaded ? 'visible' : 'hidden'}`}
                                                onLoad={() => setIsLoaded(true)}
                                            />
                                        )}
                                    </div>

                                </div>
                                <Link
                                    to={!isPastDate(data?.event_date) ? `/event-book/${data?.club_id}/${data?.id}` : "#"}
                                    style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                        pointerEvents: isPastDate(data?.event_date) ? "none" : "auto",
                                        opacity: isPastDate(data?.event_date) ? 0.6 : 1,
                                    }}
                                >
                                    <div className="carousel-actions-section">
                                        <div className="feed-book-now">Book Now</div>
                                        <i className="fi fi-br-angle-right"></i>
                                    </div>
                                </Link>

                                <div className="feed-card-content">
                                    <h3>{data?.name}</h3>
                                    <p>{data?.clubName}, {data?.event_date}, {data?.event_time}</p>
                                </div>
                            </div>
                            {/* Footer Actions */}
                            <div className="feed-card-actions-event">
                                <div className="feed-card-icons-section" style={{ pointerEvents: 'none' }}>
                                    <div className='feed-card-icon-box' onClick={(e) => handleAddRemoveFav(e, { id: data.club_id })}>
                                        <i class="fi fi-tr-circle-star feed-icons-new-card"></i>
                                    </div>
                                    {/* <div className='feed-card-icon-box'>
                                        <i class="fi fi-rr-bookmark feed-icons-new-card"></i>
                                    </div> */}
                                </div>
                                <div className="feed-card-icons-section" style={{ pointerEvents: 'none' }}>
                                    {/* <div className='feed-card-icon-box'><i class="fi fi-rr-heart feed-icons-new-card"></i> --</div>
                                    <div className='feed-card-icon-box'><i class="fi fi-rr-comment feed-icons-new-card"></i> --</div>
                                    <div className='feed-card-icon-box'><i class="fi fi-rr-paper-plane feed-icons-new-card"></i> --</div> */}
                                </div>
                            </div>
                        </div>
                    </Link>
                    {/* Content */}




                </div>
            </div>
            <ShareModal
                isOpen={isShareModalOpen}
                onClose={() => setIsShareModalOpen(false)}
                shareUrl={currentShareUrl}
                title={shareTitle}
            />
        </>
    );
}
